import { FileTypes, ExtMap } from "./config.js";

export const UUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const lString = (str, max, limiter) => {
  if (str.length > max) {
    return str.substr(0, max - limiter.length) + limiter;
  } else {
    return str;
  }
};

export const evaluate = (data) => {
  try {
    return eval(data);
  } catch (e) {
    return e.message;
  }
};

export const validEmail = (email) => {
  return /\S+@\S+\.\S+/.test(email);
};

export const validUserName = (name) => {
  return /^[a-zA-Z0-9]+$/i.test(name) && name.length >= 8 && name.length <= 16;
};

export const validPassword = (password) => {
  return (
    /^[a-zA-Z0-9]+$/i.test(password) &&
    password.length >= 8 &&
    password.length <= 16
  );
};

export const getSize = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const blobToBase64 = (blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};
export const formatDate = (date) => {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1, // months are zero indexed
    day: date.getDate(),
    second:
      date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(),
    hour: date.getHours() < 10 ? "0" + date.getHours() : date.getHours(), // hour returned in 24 hour format
    minute:
      date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
  };
};
export const blobToBin = (blob) => {
  const reader = new FileReader();
  reader.readAsBinaryString(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const blobToTxt = (blob) => {
  const reader = new FileReader();
  reader.readAsText(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const blobToArrayBuffer = (blob) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(blob);
  return new Promise((resolve) => {
    reader.onloadend = () => {
      resolve(reader.result);
    };
  });
};

export const successRes = (data) => {
  return { error: false, data };
};

export const errorRes = (errMsg, e = null) => {
  return { error: true, errMsg, e };
};

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const getFileType = (ext) => {
  if (!ext) {
    return FileTypes.TXT;
  }
  ext = ext.toLowerCase();
  for (let type of ExtMap.txtExts) {
    if (type === ext) {
      return FileTypes.TXT;
    }
  }
  for (let type of ExtMap.imgExts) {
    if (type === ext) {
      return FileTypes.IMG;
    }
  }
  for (let type of ExtMap.vidExts) {
    if (type === ext) {
      return FileTypes.VID;
    }
  }
  for (let type of ExtMap.audExts) {
    if (type === ext) {
      return FileTypes.AUD;
    }
  }
  for (let type of ExtMap.xmlExts) {
    if (type === ext) {
      return FileTypes.XML;
    }
  }
  for (let type of ExtMap.jsExts) {
    if (type === ext) {
      return FileTypes.JS;
    }
  }
  for (let type of ExtMap.docExts) {
    if (type === ext) {
      return FileTypes.DOC;
    }
  }
  for (let type of ExtMap.pptExts) {
    if (type === ext) {
      return FileTypes.PPT;
    }
  }
  for (let type of ExtMap.xlsExts) {
    if (type === ext) {
      return FileTypes.XLS;
    }
  }
  for (let type of ExtMap.otherExts) {
    if (type === ext) {
      return FileTypes.OTHER;
    }
  }
  for (let type of ExtMap.cssExts) {
    if (type === ext) {
      return FileTypes.CSS;
    }
  }
  return FileTypes.UNKNOWN;
};

export const getIP = async () => {
  const res = await fetch("https://api.ipify.org", {
    method: "GET",
  });
  const data = await res.text();
  return data;
};

export const parseCmd = (cmd) => {
  let i = 0;
  const segs = [];
  let currentSeg = "";
  while (i < cmd.length) {
    if (cmd[i] === '"') {
      i++;
      while (i < cmd.length && cmd[i] !== '"') {
        currentSeg += cmd[i];
        i++;
      }
      if (currentSeg.length > 0) {
        segs.push(currentSeg);
        currentSeg = "";
      }
      i++;
    } else if (cmd[i] === " " || cmd[i] === " ") {
      if (currentSeg === "") {
        i++;
        continue;
      }
      if (currentSeg.length > 0) {
        segs.push(currentSeg);
        currentSeg = "";
      }
      i++;
    } else {
      currentSeg += cmd[i];
      i++;
    }
  }
  if (currentSeg.length > 0) {
    segs.push(currentSeg);
    currentSeg = "";
  }
  return segs;
};
